{
  "page": {
    "title": "Expédition",
    "subtitle": "Gérez les frais d'expédition, les grilles tarifaires des transporteurs, les fournisseurs et transporteurs, les tranches de poids, les méthodes de livraison, le rapport de marge et l'historique des modifications."
  },
  "price": {
    "title": "Liste des prix d'expédition",
    "subtitle": "Gérez les prix par Service (et non par Transporteur).",
    "manageServices": "Gérer les services",
    "downloadTemplate": "Télécharger le modèle",
    "export": "Exporter",
    "importExcel": "Importer Excel",
    "addRateTable": "Ajouter une grille tarifaire"
  },
  "rateTable": {
    "title": "Grille tarifaire des transporteurs",
    "subtitle": "Tarif par zone, par fournisseur, par service.",
    "accessDenied": {
      "title": "Accès refusé",
      "body": "Vous n'avez pas l'autorisation de voir les données de coût (VIEW_FINANCIAL_COST). Contactez un administrateur si vous avez besoin d'un accès."
    }
  },
  "rateTable2": {
    "page": {
      "title": "Grille tarifaire d'expédition — Maître-Détail",
      "subtitle": "Gérez les tarifs par transporteur · comparaison inter-fournisseurs",
      "legacyLink": "Voir l'ancienne interface"
    },
    "tabs": {
      "rate": "Tarifs",
      "routing": "Routage",
      "margin": "Rapport de marge",
      "history": "Historique"
    },
    "band": {
      "label": "Comparer tous les transporteurs",
      "sub": "Trouvez le tarif le moins cher sur tous les fournisseurs · LeastCost"
    },
    "panel": {
      "title": "Transporteurs",
      "inactiveBadge": "Inactif",
      "meta": "{{carrierCount}} transporteurs · {{zoneCount}} zones"
    },
    "matrix": {
      "viewDomestic": "National",
      "viewInbound": "Entrant",
      "addRate": "Ajouter un tarif",
      "importCsv": "Importer CSV"
    },
    "empty": {
      "domestic": "Ce fournisseur n'a pas encore de grille tarifaire Nationale",
      "inbound": "Ce fournisseur n'a pas encore de grille tarifaire Entrante",
      "switchHint": "Essayez de basculer vers l'autre vue"
    },
    "readonly": {
      "banner": "Le transporteur n'est plus en service — lecture seule"
    },
    "navigation": {
      "rt2Routing": "Routage",
      "rt2Margin": "Rapport de marge",
      "rt2History": "Historique",
      "rt2Rate": "Tarifs"
    },
    "bulk": {
      "bar": "Modifier les prix en masse",
      "editPrice": "Modifier le prix",
      "selectAll": "Tout sélectionner",
      "applyTo": "Appliquer à",
      "newPrice": "Nouveau prix",
      "confirm": "Confirmer",
      "cancel": "Annuler",
      "selectedCount": "{{count}} sélectionné(s)",
      "noTargets": "Aucune cellule tarifaire à mettre à jour pour cette sélection.",
      "queued": "{{count}} demandes envoyées pour approbation (flux à deux étapes)."
    }
  },
  "tabs": {
    "fee": "Frais",
    "rate": "Tarifs",
    "routing": "Routage",
    "providers": "Fournisseurs & Transporteurs",
    "weightBands": "Tranches de poids",
    "methods": "Méthodes",
    "margin": "Rapport de marge",
    "history": "Historique"
  },
  "placeholder": {
    "comingSoon": "Bientôt disponible",
    "wave7": "Le contenu de cet onglet arrive dans la prochaine vague de livraison."
  },
  "states": {
    "loading": "Chargement…",
    "empty": "Aucune donnée pour le moment.",
    "emptyCta": "Commencez par ajouter votre premier enregistrement.",
    "errorTitle": "Échec du chargement des données",
    "retry": "Réessayer"
  },
  "approval": {
    "queued": "Demande de modification envoyée",
    "queuedFor": "Modification en attente d'approbation (flux de double approbation)."
  },
  "fee": {
    "title": "Frais d'expédition",
    "subtitle": "Gérez les frais facturés par destination, méthode et tranche de poids.",
    "countries": "Pays",
    "zip3Count": "{{count}} codes ZIP3",
    "selectCountryPrompt": "Sélectionnez un pays pour afficher le détail des frais par ZIP.",
    "zip3Grid": "Grille de frais ZIP3 — {{country}}",
    "zip5Exceptions": "Exceptions ZIP5",
    "noZip3": "Aucun frais ZIP3 pour ce pays.",
    "noZip5": "Aucune exception ZIP5.",
    "baseFee": "Frais de base (cents)",
    "additionalItemFee": "Frais par article supplémentaire (cents)",
    "save": "Enregistrer",
    "editReason": "Mise à jour des frais depuis la grille de frais d'expédition",
    "confirmNegativeMargin": "Confirmer malgré une marge négative",
    "pending": "En attente d'approbation",
    "importCsv": "Importer CSV",
    "importTitle": "Importer les frais d'expédition depuis un CSV"
  },
  "csv": {
    "fileLabel": "Fichier CSV",
    "hint": "Choisissez un fichier CSV pour prévisualiser avant de soumettre pour approbation.",
    "dryRun": "Prévisualiser",
    "dryRunning": "Prévisualisation…",
    "commit": "Soumettre pour approbation",
    "committing": "Envoi…",
    "close": "Fermer",
    "summary": "{{total}} lignes au total — {{ok}} valides, {{errors}} erreurs.",
    "colRow": "Ligne",
    "colStatus": "Statut",
    "colErrors": "Erreurs",
    "statusOk": "Valide",
    "statusError": "Erreur",
    "queuedSummary": "{{count}} lignes soumises pour approbation.",
    "deduped": "(La demande existait déjà — dédupliquée.)"
  },
  "deprecate": {
    "title": "La configuration des tarifs d'expédition a été déplacée vers la nouvelle page Expédition",
    "body": "Cet onglet (v1) sera retiré. Veuillez utiliser la nouvelle page Grille tarifaire des transporteurs pour gérer les coûts et les grilles tarifaires d'expédition.",
    "cta": "Ouvrir la nouvelle page Grille tarifaire"
  },
  "providers": {
    "filter": {
      "searchPlaceholder": "Rechercher par nom ou code",
      "showDeleted": "Afficher les supprimés"
    },
    "col": {
      "name": "Nom",
      "code": "Code",
      "agency": "Agence",
      "credential": "Identifiant",
      "adapter": "Adaptateur tarif en direct",
      "status": "Statut",
      "actions": "Actions"
    },
    "status": {
      "active": "Actif",
      "inactive": "Inactif",
      "deleted": "Supprimé"
    },
    "actions": {
      "edit": "Modifier",
      "delete": "Supprimer",
      "restore": "Restaurer"
    },
    "agencies": {
      "title": "Agences",
      "subtitle": "Sommet de l'arbre Agence → Fournisseur → Transporteur.",
      "create": "Ajouter une agence",
      "createTitle": "Ajouter une agence",
      "editTitle": "Modifier l'agence"
    },
    "providers": {
      "title": "Fournisseurs",
      "subtitle": "L'identifiant d'API est en écriture seule — seul le statut défini/non défini est affiché.",
      "create": "Ajouter un fournisseur",
      "createTitle": "Ajouter un fournisseur",
      "editTitle": "Modifier le fournisseur",
      "needAgency": "Créez d'abord une agence avant d'ajouter un fournisseur."
    },
    "carriers": {
      "title": "Transporteurs",
      "subtitle": "Registre piloté par les données — ajoutez un transporteur sans modifier le code.",
      "create": "Ajouter un transporteur",
      "createTitle": "Ajouter un transporteur",
      "editTitle": "Modifier le transporteur",
      "adapterYes": "Oui",
      "adapterNo": "Non"
    },
    "credential": {
      "label": "Identifiant d'API (écriture seule)",
      "statusSet": "Défini",
      "statusUnset": "Non défini",
      "placeholderSet": "Saisir un nouveau secret d'identifiant",
      "placeholderRotate": "Saisir un nouveau secret pour rotation",
      "help": "Le secret n'est jamais réaffiché après l'enregistrement. Laissez vide pour conserver l'identifiant actuel.",
      "clear": "Effacer l'identifiant stocké"
    },
    "matrix": {
      "title": "Activation Fournisseur–Transporteur",
      "subtitle": "Activez un transporteur sous un fournisseur pour la tarification des nouvelles commandes. La désactivation ne redirige pas les commandes déjà validées.",
      "providerCol": "Fournisseur",
      "enabled": "Activé",
      "disabled": "Désactivé",
      "noLink": "non lié",
      "empty": "Ajoutez des fournisseurs et des transporteurs pour gérer leur activation."
    },
    "form": {
      "name": "Nom",
      "code": "Code",
      "agency": "Agence",
      "agencyPlaceholder": "Sélectionner une agence",
      "status": "Statut",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "cancel": "Annuler",
      "errName": "Le nom est requis.",
      "errCode": "Le code doit comporter 2 à 40 caractères : A–Z, 0–9, _ ou -.",
      "errAgency": "Sélectionnez une agence."
    },
    "confirm": {
      "deleteTitle": "Supprimer {{name}} ?",
      "deleteBody": "Il s'agit d'une suppression réversible — l'enregistrement peut être restauré. S'il est encore référencé, la suppression est bloquée.",
      "deleteConfirm": "Supprimer",
      "cancel": "Annuler"
    },
    "toast": {
      "saved": "Enregistré",
      "saveFailed": "Échec de l'enregistrement",
      "deleted": "Supprimé",
      "deleteFailed": "Échec de la suppression",
      "restored": "Restauré",
      "restoreFailed": "Échec de la restauration",
      "toggleSaved": "Activation mise à jour",
      "toggleFailed": "Échec de la mise à jour de l'activation"
    }
  },
  "rate": {
    "matrix": {
      "weightColumn": "Poids",
      "gramColumn": "Gramme (g)",
      "zoneHeader": "Zone {{n}}",
      "emptyCell": "—",
      "empty": "Aucune grille tarifaire pour ce transporteur.",
      "providerFilter": {
        "label": "Filtrer par transporteur",
        "all": "Tous les transporteurs",
        "selectAll": "Tout sélectionner",
        "deselectAll": "Tout désélectionner"
      },
      "viewSwitch": {
        "domestic": "National US",
        "inbound": "Entrant US"
      },
      "inbound": {
        "priceColumn": "Prix forfaitaire"
      },
      "invalidRate": "Le tarif doit être un nombre positif ou nul.",
      "changeReason": "Mettre à jour le coût de la route depuis la grille tarifaire.",
      "editTitle": "Demande de modification de tarif",
      "rateCents": "Tarif (cents)",
      "cancel": "Annuler",
      "submitRequest": "Envoyer la demande",
      "weightCol": "Poids",
      "gramCol": "Grammes (g)",
      "providerHeader": "Fournisseur",
      "zoneLabel": "Zone {{n}}",
      "filter": {
        "label": "Filtrer les fournisseurs",
        "all": "Tous"
      },
      "view": {
        "label": "Mode d'affichage de la grille tarifaire",
        "domestic": "US National",
        "inbound": "US Import"
      },
      "meta": "Matrice de tarifs par poids × zone · USD"
    },
    "override": {
      "pinned": "Route épinglée.",
      "unpinned": "Route désépinglée.",
      "title": "Épingler la route (priorité de remplacement)",
      "provider": "Fournisseur",
      "selectOption": "— Sélectionner —",
      "destType": "Type de destination",
      "destKey": "Clé de destination",
      "destPlaceholder": "Code postal / pays / zone",
      "method": "Méthode",
      "band": "Tranche de poids",
      "reason": "Raison de l'épinglage",
      "reasonPlaceholder": "Pourquoi épingler ce fournisseur pour la route ?",
      "pin": "Épingler le fournisseur",
      "selectFirst": "Sélectionnez un fournisseur à épingler.",
      "empty": "Aucune route épinglée.",
      "unpin": "Désépingler"
    },
    "noAccess": "Vous n'avez pas la permission de voir les données de coût.",
    "import": "Importer CSV",
    "pending": {
      "badge": "En attente d'approbation"
    },
    "preview": {
      "errDest": "Saisissez une destination (code postal/pays).",
      "errWeight": "Le poids doit être un nombre de grammes positif.",
      "errMethod": "Sélectionnez une méthode de livraison.",
      "missingRoute": "Aucune route correspondante pour cette destination et ce poids.",
      "title": "Aperçu du coût le plus bas",
      "destination": "Destination",
      "weight": "Poids (g)",
      "method": "Méthode",
      "methodAny": "— Sélectionner —",
      "run": "Voir le coût",
      "cheapest": "Le moins cher",
      "pinned": "Épinglé"
    },
    "providerTab": {
      "empty": "Ce fournisseur n’a pas encore de grille tarifaire.",
      "label": "Sélectionner un transporteur"
    },
    "serviceBlock": {
      "heading": "Service : {{name}}"
    }
  },
  "errors": {
    "loadFee": "Échec du chargement des grilles de frais d'expédition.",
    "loadRate": "Échec du chargement des grilles tarifaires des transporteurs.",
    "loadProviders": "Échec du chargement des fournisseurs.",
    "loadCarriers": "Échec du chargement des transporteurs.",
    "loadProviderCarriers": "Échec du chargement des liens fournisseur-transporteur.",
    "loadAgencies": "Échec du chargement des agences.",
    "loadWeightBands": "Échec du chargement des tranches de poids.",
    "loadMethods": "Échec du chargement des méthodes de livraison.",
    "loadMethodServiceMaps": "Échec du chargement des mappages de service.",
    "loadRouteOverrides": "Échec du chargement des remplacements d'itinéraire.",
    "loadMarginReport": "Échec du chargement du rapport de marge.",
    "ratePreview": "Échec de la récupération de l'aperçu des coûts.",
    "import": "Échec du traitement du fichier d'import.",
    "network": "Erreur réseau - vérifiez la connexion"
  },
  "ratesTab": {
    "toast": {
      "saved": "Table de tarifs enregistrée pour {{name}}",
      "saveFailed": "Impossible d'enregistrer la table de tarifs pour {{name}}"
    },
    "saving": "Enregistrement…",
    "loadError": "Impossible de charger les tarifs d'expédition.",
    "retry": "Réessayer",
    "empty": "Aucune catégorie d'expédition pour le moment.",
    "intro": "Chaque catégorie d'expédition gère une matrice de 7 zones × 2 niveaux de vitesse (14 cellules au total). Cliquez sur une ligne pour ouvrir/fermer la matrice en ligne.",
    "reasonLabel": "Motif du changement (≥10 caractères, obligatoire)"
  },
  "configProvider": {
    "title": "Fournisseur",
    "subtitle": "Gérez les agences, les fournisseurs et les bascules Fournisseur–Transporteur. Les identifiants d'API sont en écriture seule et ne sont jamais réaffichés.",
    "agencyTitle": "Agence",
    "agencySubtitle": "Une agence est le parent d'un fournisseur.",
    "providerTitle": "Fournisseur",
    "providerSubtitle": "Un fournisseur appartient à une agence ; son identifiant est en écriture seule.",
    "matrixTitle": "Bascules Fournisseur – Transporteur",
    "matrixSubtitle": "Activez/désactivez chaque paire Fournisseur–Transporteur pour router les devis.",
    "matrixEmpty": "Au moins un fournisseur et un transporteur sont requis.",
    "matrixProviderCol": "Fournisseur",
    "matrixEnabled": "Activé",
    "matrixDisabled": "Désactivé",
    "matrixNoLink": "(aucun lien)",
    "addAgency": "Ajouter une agence",
    "addProvider": "Ajouter un fournisseur",
    "needAgency": "Créez une agence avant d’ajouter un fournisseur.",
    "edit": "Modifier",
    "restore": "Restaurer",
    "delete": "Supprimer",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "create": "Créer",
    "saving": "Enregistrement…",
    "colName": "Nom",
    "colCode": "Code",
    "colAgency": "Agence",
    "colCredential": "Identifiant",
    "colStatus": "Statut",
    "colActions": "Actions",
    "name": "Nom",
    "code": "Code",
    "agency": "Agence",
    "agencyPlaceholder": "Sélectionnez une agence",
    "status": "Statut",
    "statusActive": "Actif",
    "statusInactive": "Inactif",
    "statusDeleted": "Supprimé",
    "credentialSet": "Défini",
    "credentialUnset": "Non défini",
    "agencyCreateTitle": "Créer une agence",
    "agencyEditTitle": "Modifier l’agence",
    "providerCreateTitle": "Créer un fournisseur",
    "providerEditTitle": "Modifier le fournisseur",
    "deleteAgencyTitle": "Supprimer l’agence",
    "deleteProviderTitle": "Supprimer le fournisseur",
    "deleteConfirm": "Supprimer cet enregistrement ? Un enregistrement référencé ne peut pas être supprimé.",
    "errName": "Le nom est requis.",
    "errCode": "Le code doit comporter 2 à 40 caractères A–Z, 0–9, _ ou -.",
    "errAgency": "Veuillez sélectionner une agence.",
    "saved": "Enregistré",
    "restored": "Restauré",
    "deletedToast": "Supprimé",
    "toggleSaved": "Bascule enregistrée",
    "staleVersion": "Cet enregistrement a changé ailleurs — rechargé, veuillez réessayer.",
    "fkRestrict": "Suppression impossible : l’enregistrement est référencé."
  },
  "routes": {
    "title": "Itinéraires de livraison",
    "subtitle": "Gérez les itinéraires de livraison internationaux et nationaux",
    "add": "+ Ajouter un itinéraire",
    "searchPlaceholder": "Rechercher par code, nom…",
    "filterTypeAll": "Tous les types",
    "filterOriginAll": "Toutes les origines",
    "filterDestinationAll": "Toutes les destinations",
    "colRoute": "ITINÉRAIRE",
    "colType": "TYPE",
    "colCarrier": "TRANSPORTEUR",
    "colServiceArea": "ZONE",
    "colEstDays": "JOURS EST.",
    "colBaseFee": "FRAIS DE BASE",
    "colXBorder": "TRANSFRONT.",
    "colStatus": "STATUT",
    "colActions": "ACTIONS",
    "empty": "Aucun itinéraire de livraison pour le moment",
    "total": "Total : {{count}}",
    "show": "Afficher :",
    "edit": "Modifier",
    "delete": "Supprimer",
    "cancel": "Annuler",
    "save": "Enregistrer la config",
    "create": "Créer l'itinéraire",
    "createTitle": "Configuration de l'itinéraire",
    "editTitle": "Modifier la configuration de l'itinéraire",
    "deleteTitle": "Supprimer la configuration de l'itinéraire",
    "deleteConfirm": "Supprimer cette configuration de routage ? Un itinéraire sans configuration de répartition revient au coût le plus bas.",
    "destinationType": "Type de destination",
    "destinationKey": "Clé de destination",
    "methodId": "Service (méthode)",
    "weightBandId": "Tranche de poids",
    "destType": {
      "us_zip5": "US ZIP5",
      "us_zip3": "US ZIP3",
      "country": "Pays",
      "zone": "Zone"
    },
    "saved": "Configuration de routage enregistrée",
    "deletedToast": "Configuration d'itinéraire supprimée",
    "duplicate": "Cet itinéraire a déjà une configuration de routage active.",
    "staleVersion": "Cet enregistrement a changé ailleurs — rechargé, veuillez réessayer.",
    "invalidWeights": "La somme des poids doit être égale à 100.",
    "inactiveProvider": "Fournisseur inactif — ne peut pas être réparti.",
    "forbidden": "Vous n'avez pas la permission VIEW_FINANCIAL_COST.",
    "split": {
      "title": "Répartition en % par fournisseur",
      "subtitle": "Saisissez un % pour chaque fournisseur actif. La somme doit être égale à 100.",
      "sumLabel": "Total",
      "sumOk": "Total = 100 ✓",
      "sumInvalid": "Le total doit être égal à 100 (actuellement {{sum}})",
      "noActive": "Aucun ProviderCarrier actif — impossible de configurer une répartition en %.",
      "weightSuffix": "%",
      "autoTitle": "Poids auto-calculés (lecture seule)",
      "autoSubtitle": "Les poids sont dérivés du score fournisseur ; l'administrateur ne peut pas les modifier directement.",
      "autoStubNote": "TODO(M1-stub) : le pipeline de scoring n'est pas encore prêt — poids par défaut répartis également.",
      "derivedSuffix": "% (auto)"
    },
    "mode": {
      "label": "Mode de routage",
      "least_cost": "Coût le plus bas",
      "percent_split": "Répartition en %",
      "auto_score": "Score automatique",
      "leastCostHint": "Par défaut : choisit le fournisseur le moins cher quand un itinéraire n'a pas de configuration de répartition.",
      "percentSplitHint": "Répartit le trafic en % entre les fournisseurs actifs ; la somme doit être égale à 100.",
      "autoScoreHint": "Les poids sont calculés automatiquement à partir du score fournisseur (SLA/erreur/CS) — lecture seule.",
      "pinOverrideNote": "Note : un itinéraire épinglé (pin-override) l'emporte sur TOUS les modes de routage. Sans configuration de répartition, le routeur revient au coût le plus bas."
    }
  },
  "zone": {
    "title": "Zone",
    "subtitle": "Gérez les zones par emplacement entrepôt/usine pour la tarification du dernier kilomètre. Une zone créée apparaît dans la recherche de prix du dernier kilomètre.",
    "add": "Ajouter une zone",
    "edit": "Modifier",
    "restore": "Restaurer",
    "delete": "Supprimer",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "create": "Créer une zone",
    "createTitle": "Créer une zone",
    "editTitle": "Modifier la zone",
    "deleteTitle": "Supprimer la zone",
    "deleteConfirm": "Supprimer cette zone ? Une zone référencée par des grilles de frais/tarifs ne peut pas être supprimée.",
    "colZone": "Zone",
    "colWarehouse": "Entrepôt",
    "colFactory": "Usine",
    "colLastMile": "Dernier km",
    "colStatus": "Statut",
    "colActions": "Actions",
    "zoneKey": "Clé de zone",
    "zoneKeyHint": "Jusqu'à 40 caractères, unique.",
    "warehouseLocationKey": "Emplacement entrepôt (origine)",
    "factoryLocationKey": "Emplacement usine (optionnel)",
    "carrierHint": "Indice de transporteur (optionnel)",
    "lastMileEnabled": "Activer le dernier kilomètre",
    "status": "Statut",
    "statusActive": "Actif",
    "statusInactive": "Inactif",
    "statusDeleted": "Supprimé",
    "lastMileOn": "Activé",
    "lastMileOff": "Désactivé",
    "none": "—",
    "saved": "Zone enregistrée",
    "restored": "Zone restaurée",
    "deletedToast": "Zone supprimée",
    "staleVersion": "Cet enregistrement a changé ailleurs — rechargé, veuillez réessayer.",
    "duplicate": "La clé de zone existe déjà — création de doublon impossible.",
    "fkRestrict": "Suppression impossible : la zone est référencée par des grilles de frais/tarifs.",
    "errorValidation": "Données invalides."
  },
  "configCarrier": {
    "title": "Transporteur",
    "subtitle": "Gérez le répertoire des transporteurs (USPS/UPS/FedEx…). Les transporteurs avec un adaptateur prennent en charge les devis tarifaires automatisés.",
    "add": "Ajouter un transporteur",
    "edit": "Modifier",
    "restore": "Restaurer",
    "delete": "Supprimer",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "create": "Créer un transporteur",
    "createTitle": "Créer un transporteur",
    "editTitle": "Modifier le transporteur",
    "deleteTitle": "Supprimer le transporteur",
    "deleteConfirm": "Supprimer ce transporteur ? Un transporteur référencé ne peut pas être supprimé.",
    "colName": "Nom",
    "colCode": "Code",
    "colAdapter": "Adaptateur",
    "colStatus": "Statut",
    "colActions": "Actions",
    "name": "Nom",
    "code": "Code",
    "status": "Statut",
    "statusActive": "Actif",
    "statusInactive": "Inactif",
    "statusDeleted": "Supprimé",
    "adapterYes": "Adaptateur présent",
    "adapterNo": "Aucun adaptateur",
    "errName": "Le nom est requis.",
    "errCode": "Le code doit comporter 2 à 40 caractères A–Z, 0–9, _ ou -.",
    "saved": "Transporteur enregistré",
    "restored": "Transporteur restauré",
    "deletedToast": "Transporteur supprimé",
    "staleVersion": "Cet enregistrement a changé ailleurs — rechargé, veuillez réessayer.",
    "fkRestrict": "Suppression impossible : le transporteur est référencé."
  },
  "dutyRate": {
    "title": "Droits d'importation",
    "subtitle": "Configurez les droits d'importation par zone (s'appliquent aux commandes de vendeurs hors US livrées aux US). DDP : la plateforme facture les droits ; DDU : l'acheteur paie à la douane.",
    "colZone": "Zone",
    "colPercent": "Taux de droit (%)",
    "colPayer": "Payeur des droits",
    "colMultiplier": "Multiplicateur douanier",
    "colActions": "Actions",
    "percent": "Taux de droit d'importation (%)",
    "percentHint": "Entre 0 et 100.",
    "payer": "Payeur des droits",
    "payerDDP": "DDP (droits acquittés à la livraison)",
    "payerDDU": "DDU (droits non acquittés à la livraison)",
    "multiplier": "Multiplicateur douanier (optionnel)",
    "multiplierHint": "Laissez vide = conserver la valeur actuelle.",
    "edit": "Modifier",
    "save": "Enregistrer",
    "cancel": "Annuler",
    "unset": "Non configuré",
    "saved": "Droit d'importation enregistré",
    "staleVersion": "Cet enregistrement a changé ailleurs — rechargé, veuillez réessayer.",
    "forbidden": "Vous n'avez pas la permission de voir/modifier les droits d'importation (coût).",
    "errorRange": "Le taux de droit doit être compris entre 0 et 100.",
    "errorValidation": "Données invalides."
  },
  "methods": {
    "title": "Méthodes de livraison",
    "subtitle": "Créez une méthode (toujours en brouillon), puis ajoutez au moins un mappage de service avant de l'activer.",
    "add": "Ajouter une méthode",
    "name": "Nom",
    "code": "Code (A-Z, 0-9, _ -)",
    "colName": "Nom",
    "colCode": "Code",
    "colStatus": "Statut",
    "colMaps": "Mappages",
    "colActions": "Actions",
    "statusDraft": "Brouillon",
    "statusActive": "Actif",
    "statusInactive": "Inactif",
    "deleted": "Supprimé",
    "activate": "Activer",
    "deactivate": "Désactiver",
    "delete": "Supprimer",
    "restore": "Restaurer",
    "manageMaps": "Mappages de service",
    "addServiceMap": "Ajouter un mappage",
    "providerCarrier": "Fournisseur · Transporteur",
    "serviceCode": "Code de service (ex : usps_priority)",
    "noMaps": "Aucun mappage pour le moment. Ajoutez-en au moins un pour activer la méthode.",
    "mapsCount": "{{count}} mappages",
    "saved": "Méthode enregistrée",
    "activated": "Méthode activée",
    "deactivated": "Méthode désactivée",
    "deletedToast": "Méthode supprimée",
    "restored": "Méthode restaurée",
    "mapSaved": "Mappage enregistré",
    "mapDeleted": "Mappage supprimé",
    "staleVersion": "Cet enregistrement a changé ailleurs — rechargé, veuillez réessayer.",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "close": "Fermer",
    "activateNeedsMap": "La méthode a besoin d'au moins un mappage de service pour être activée.",
    "lastMapGuard": "Impossible de retirer le seul mappage d'une méthode active.",
    "duplicateMap": "Ce mappage de service existe déjà.",
    "loadMapsError": "Échec du chargement des mappages de service."
  },
  "weightBands": {
    "title": "Tranches de poids",
    "subtitle": "Intervalles semi-ouverts [min, max) en grammes — min inclus, max exclu. La tranche supérieure est illimitée (laissez max vide).",
    "add": "Ajouter une tranche",
    "edit": "Modifier",
    "restore": "Restaurer",
    "delete": "Supprimer",
    "colInterval": "Intervalle",
    "colLabel": "Libellé",
    "colStatus": "Statut",
    "colActions": "Actions",
    "minGrams": "Min (grammes, inclus)",
    "maxGrams": "Max (grammes, exclu)",
    "maxGramsHint": "Laissez vide = illimité (tranche supérieure).",
    "label": "Libellé",
    "unbounded": "Illimité",
    "deleted": "Supprimé",
    "saved": "Tranche de poids enregistrée",
    "restored": "Tranche de poids restaurée",
    "deletedToast": "Tranche de poids supprimée",
    "staleVersion": "Cet enregistrement a changé ailleurs — rechargé, veuillez réessayer.",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "errorOverlap": "Les tranches de poids se chevauchent.",
    "errorGap": "Les tranches de poids laissent un intervalle non couvert.",
    "errorNoUnbounded": "Exactement une tranche supérieure illimitée (max vide) est requise.",
    "errorValidation": "Max doit être supérieur à min (semi-ouvert [min, max))."
  },
  "history": {
    "heading": "Historique des modifications de tarifs / frais d'expédition",
    "subtitle": "Journal des modifications daté par effet pour les grilles tarifaires et les tables de frais (ancien → nouveau), avec le demandeur et l'approbateur (flux de double approbation).",
    "empty": "Aucune modification de tarif / frais d'expédition pour le moment.",
    "error": "Échec du chargement de l'historique des modifications.",
    "view": "Voir le détail",
    "col": {
      "effectiveFrom": "En vigueur à partir de",
      "target": "Cible",
      "newValue": "Nouvelle valeur",
      "status": "Statut",
      "requestedBy": "Demandé par",
      "approvedBy": "Approuvé par"
    },
    "target": {
      "rateCard": "Grille tarifaire du transporteur",
      "feeTable": "Table de frais"
    },
    "status": {
      "pending": "En attente",
      "approved": "Approuvé",
      "rejected": "Rejeté",
      "expired": "Expiré"
    },
    "detail": {
      "title": "Détail de la modification",
      "close": "Fermer",
      "supersedes": "Remplace la ligne",
      "netNew": "Nouveau (sans remplacement)",
      "decidedAt": "Décidé le",
      "costRedacted": "Certains champs de coût sont masqués car vous n'avez pas la visibilité des coûts."
    }
  },
  "margin": {
    "heading": "Rapport de marge par itinéraire",
    "subtitle": "Marge par itinéraire = Frais − coût réel du transporteur (revient à l'estimation tant qu'aucune étiquette n'est achetée).",
    "forbidden": "Vous n'avez pas l'autorisation de voir les données de coût (VIEW_FINANCIAL_COST).",
    "filterRoute": "Filtrer par type d'itinéraire",
    "filterAll": "Tous les itinéraires",
    "empty": "Aucun itinéraire avec un coût réel pour afficher une marge.",
    "estimateBadge": "(estimation)",
    "estimateFallback": "Aucune étiquette achetée — utilisation du coût estimé.",
    "varianceExceeded": "Dépassé",
    "varianceOk": "Dans le seuil",
    "destinationType": {
      "us_zip5": "ZIP-5 (US)",
      "us_zip3": "ZIP-3 (US)",
      "country": "Pays",
      "zone": "Zone"
    },
    "col": {
      "route": "Itinéraire",
      "fee": "Frais",
      "actualRate": "Coût réel",
      "margin": "Marge",
      "variance": "Écart",
      "flag": "Indicateur"
    }
  },
  "config": {
    "title": "Configuration d'expédition",
    "subtitle": "Gérez les zones, transporteurs, services, itinéraires de livraison, droits d'importation, fournisseurs et tranches de poids.",
    "tabs": {
      "zone": "Zone",
      "carrier": "Transporteur",
      "service": "Service",
      "shippingRoutes": "Itinéraires de livraison",
      "dutyRate": "Droits d'importation",
      "provider": "Fournisseur",
      "weightBands": "Tranches de poids"
    },
    "service": {
      "title": "Services d'expédition",
      "subtitle": "Gérez les services de livraison (indépendants du Transporteur).",
      "rateTables": "Grilles tarifaires",
      "addService": "+ Ajouter un service"
    },
    "comingSoon": "Bientôt disponible",
    "comingSoonHint": "Le contenu de cet onglet arrivera dans la prochaine vague."
  },
  "trackRouting": {
    "title": "Suivi des expéditions",
    "subtitle": "Surveillez la performance SLA et suivez toutes les expéditions",
    "dashboardTitle": "Tableau de bord de performance SLA",
    "cards": {
      "on_time_rate": {
        "label": "Taux de livraison à temps",
        "sub": "{{numerator}} / {{denominator}} expéditions"
      },
      "avg_delivery_days": {
        "label": "Délai de livraison moyen",
        "sub": "De l'expédition à la livraison"
      },
      "delayed": {
        "label": "Retardé",
        "sub": "Au-delà de la livraison estimée"
      },
      "exceptions": {
        "label": "Exceptions",
        "sub": "Nécessite une attention"
      },
      "active_time": {
        "label": "Temps actif",
        "sub": "{{count}} expéditions · moy {{avgHrs}} · max {{maxHrs}}"
      },
      "last_mile_time": {
        "label": "Temps du dernier kilomètre",
        "sub": "{{count}} expéditions · moy {{avgHrs}} · max {{maxHrs}}"
      }
    },
    "statusOverview": {
      "title": "Aperçu du statut des expéditions",
      "delivered": "Livré",
      "inTransit": "En transit",
      "pendingPickup": "En attente de ramassage",
      "delayed": "Retardé",
      "exceptions": "Exceptions"
    },
    "alerts": {
      "title": "Alertes des expéditions",
      "summary": "{{critical}} critique, {{warnings}} avertissements",
      "empty": "Aucune alerte.",
      "collapse": "Réduire les alertes",
      "expand": "Développer les alertes",
      "ageDays": "+{{count}} jours",
      "view": "Voir",
      "openExternal": "Ouvrir le lien de suivi",
      "kind": {
        "exception": "Exception",
        "sla_at_risk": "Risque SLA",
        "delayed": "Retardé"
      }
    },
    "tabs": {
      "all": "Tout",
      "in_transit": "En transit",
      "delivered": "Livré",
      "delayed": "Retardé",
      "exceptions": "Exceptions"
    },
    "toolbar": {
      "searchPlaceholder": "Rechercher par numéro de suivi ou commande…",
      "allStatuses": "Tous les statuts",
      "allCarriers": "Tous les transporteurs"
    },
    "table": {
      "columns": {
        "trackingNumber": "NUMÉRO DE SUIVI",
        "carrier": "TRANSPORTEUR",
        "orderRef": "COMMANDE",
        "status": "STATUT",
        "shipped": "EXPÉDIÉ",
        "estimatedDelivery": "LIVRAISON ESTIMÉE",
        "firstScan": "PREMIER SCAN",
        "delivered": "LIVRÉ",
        "sla": "SLA",
        "actions": "ACTIONS"
      },
      "status": {
        "delivered": "Livré",
        "in_transit": "En transit",
        "out_for_delivery": "En cours de livraison",
        "label_created": "Étiquette créée",
        "pending_pickup": "En attente de ramassage",
        "delayed": "Retardé",
        "exception": "Exception"
      },
      "deliveredPrefix": "Livré",
      "delayDays": "+{{count}} jours de retard",
      "slaDays": "{{count}}j",
      "empty": "Aucune expédition ne correspond au filtre actif.",
      "notShipped": "—",
      "viewAction": "Voir les détails",
      "openExternal": "Ouvrir le lien de suivi"
    },
    "pagination": {
      "total": "Total : {{count}}",
      "show": "Afficher",
      "prev": "Page précédente",
      "next": "Page suivante"
    },
    "window": {
      "7d": "7 jours",
      "30d": "30 jours",
      "90d": "90 jours",
      "aria": "Fenêtre des métriques SLA"
    },
    "actions": {
      "trackingUnavailable": "Lien de suivi indisponible : numéro de suivi manquant ou invalide, ou transporteur non pris en charge.",
      "detailsUnavailable": "Détails de la commande indisponibles : identifiant de commande manquant ou invalide."
    },
    "dashboardEmpty": "Aucune donnée sur cette période"
  },
  "_vgBinding": "vg-binding: P9.2.D-11 P9.2.D-04 P9.2.D-01 P9.2.D-02 P9.2.D-12 — shipping i18n bundles moved from inline .ts to canonical shipping.json: methods/weightBands/history/margin [task-03]; trackRouting (TrackRoutingPage+ShipmentTable) + config (ConfigPage) [task-05]. vg-binding: P4.8.D-06 P4.8.D-22 (G-13) — rateTable2.navigation (CR-1 submenu labels) + rateTable2.bulk (CR-2 bulk-action labels) added across en/vi/fr [task-09]"
}
